import { render } from "./questions-page.vue?vue&type=template&id=404f5e4e&scoped=true"
import script from "./questions-page.vue?vue&type=script&lang=js"
export * from "./questions-page.vue?vue&type=script&lang=js"

import "./questions-page.vue?vue&type=style&index=0&id=404f5e4e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-404f5e4e"]])

export default __exports__